import { createRouter, createWebHistory } from 'vue-router';
import firebase from 'firebase';
import dashboard from '@/views/dashboard.vue';
import auth from '@/views/auth.vue';

const routes = [
  {
    path: '/:catchAll(.*)',
    redirect: '/auth',
  },
  {
    path: '/auth',
    name: 'auth',
    component: auth,
  },
  {
    path: '/',
    name: 'dashboard',
    component: dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
  const { currentUser } = firebase.auth();
  if (requiresAuth && !currentUser) next({ path: '/auth' });
  else if (!requiresAuth && currentUser) next('/');
  else if (!requiresAuth && !currentUser) next();
  else next();
});

export default router;
